import React from 'react';

function getStorageValue<T>(key: string, defaultValue: T) {
	const saved = localStorage.getItem(key);
	return saved ? JSON.parse(saved) : defaultValue;
}

export default function useLocalStorage<T = any>(
	key: string | undefined,
	defaultValue: T
): [T | undefined, React.Dispatch<React.SetStateAction<T | undefined>>] {
	const [value, setValue] = React.useState<T | undefined>(key ? getStorageValue(key, defaultValue) : undefined);

	React.useEffect(() => {
		if (key && value !== undefined) localStorage.setItem(key, JSON.stringify(value));
		if (key && value === undefined) localStorage.removeItem(key);
	}, [key, value]);

	return [value, setValue];
}
